export default function vendasDTO(data) {
  return {
    DATAVENDA: data.dataVenda,
    IDCADASTRO: data.idCadastro,
    IDPAGTO: data.idPagto,
    valor_total: data.valorTotal,
    desconto: data.desconto,
    valor_total_com_desconto: data.valorTotalComDesconto,
    OBSERVACAO: data.observacao,
    PAGO: data.pago,
    CANCELADA: data.cancelada,

    ITENS: data.itens.map(item => ({
      IDPRODUTO: item.idProduto,
      QUANTIDADE: item.quantidade,
      valor_unitario: item.valorUnitario,
      valor_total: item.valorTotal
    }))
  };
}